var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFav = function SvgFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1 5.571a6.333 6.333 0 0 1 8.956 0 6.333 6.333 0 1 1 8.957 8.957l-8.957 8.956L3.1 14.528a6.333 6.333 0 0 1 0-8.957Z",
    fill: "#FF5C39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.056 5.571-.353.354a.5.5 0 0 0 .707 0l-.354-.354Zm0 17.913-.353.354a.5.5 0 0 0 .707 0l-.354-.354Zm.354-18.267a6.833 6.833 0 0 0-9.664 0l.707.708a5.833 5.833 0 0 1 8.25 0l.707-.708Zm0 .708a5.833 5.833 0 0 1 8.25 0l.707-.708a6.833 6.833 0 0 0-9.664 0l.707.708Zm8.25 0a5.833 5.833 0 0 1 0 8.25l.707.706a6.833 6.833 0 0 0 0-9.664l-.707.708Zm-8.25 17.913 8.957-8.957-.707-.707-8.957 8.957.707.707ZM2.746 14.88l8.957 8.957.707-.707-8.957-8.957-.707.707Zm0-9.664a6.833 6.833 0 0 0 0 9.664l.707-.707a5.833 5.833 0 0 1 0-8.25l-.707-.707Z",
    fill: "#000"
  })));
};
export default SvgFav;